import React, {Component} from "react";
import "./enroll.css";
import flyer from "../../images/MLPython/flyer.png";

class MlPythonForm extends Component {
    constructor(props) {
        super(props);

        this.state = {};

    }

    render() {
        return (
            <div className="container">
                <div className="container d-flex justify-content-center">
                    <button onClick={this.handleOnClick} type="button" className="btn btn-info"> Register Here </button>
                </div>
                <hr />
                <div className="container d-flex justify-content-center">
                    <img src={flyer} height={"480px"} width={"100%"} alt={"Machine Learning with Python"}/>
                </div>
            </div>
        );
    }

    handleOnClick() {
        window.open("https://rzp.io/l/EnggGuruMLWithPython", '_blank');
    }
}

MlPythonForm.propTypes = {};

export default MlPythonForm;
